import { assignInlineVars } from "@vanilla-extract/dynamic";
import clsx from "clsx";
import React, { forwardRef } from "react";
import {
  type HighlightIconColor,
  highlightIconColorVariants,
  highlightIconContainerClass,
  innerDivClass,
  sizeVar,
  svgClass,
} from "./styles.css";

interface HighlightIconProps extends React.HTMLAttributes<HTMLDivElement> {
  icon: React.ReactElement;
  color?: HighlightIconColor;
  size?: number;
}

export const HighlightIcon = forwardRef(function HighlightIcon(
  {
    icon,
    color = "primary",
    size = 24,
    className,
    ...props
  }: HighlightIconProps,
  ref: React.Ref<HTMLDivElement>,
) {
  const sizeNum = typeof size === "string" ? parseInt(size, 10) : size;

  return (
    <div
      ref={ref}
      className={clsx(
        highlightIconContainerClass,
        highlightIconColorVariants[color],
        className,
      )}
      style={assignInlineVars({ [sizeVar]: `${sizeNum}px` })}
      {...props}
    >
      <div className={innerDivClass}>
        {React.cloneElement(icon, { className: svgClass })}
      </div>
    </div>
  );
});

HighlightIcon.displayName = "HighlightIcon";
